<template>
	<div class="search" :class="{searching: search.length}">
		<div class="search-wrapper">
			<div class="input-field">
				<input type="text" class="input"
					v-model="search"
					:placeholder="placeholder"
					@keyup.enter="selectFocused()"
					@keydown.arrow-down="moveDown()"
					@keydown.arrow-up="moveUp()"
				/>
				<div class="icon search-icon" v-if="search.length === 0">
					<search-icon/>
				</div>
				<div class="icon close-icon" v-if="search.length" @click="unsearch()">
					<close-icon/>
				</div>
			</div>

			<div class="results" v-if="results.length" >
				<div class="results-wrapper" ref="select">
					<div @click="select(index)"
						v-for="(r, index) in results"
						v-bind:key="r.code"
						:class="{'focused' : index === focusedItem}"
					>
						<span class="nom">{{ r.nom }}</span>
						<span class="departement">{{ r.codeDepartement }}</span>						</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import debounce from 'lodash/debounce';
import axios from 'axios';
import {event, pageView} from '@/analytics';

import diacritics from 'diacritics';



import SearchIcon from './icons/loupe.svg'
import CloseIcon from './icons/fermer.svg'
import texts from '@texts/controls.json'

const min = Math.min

export default {
	name: 'Search',
	components: {
		SearchIcon,
		CloseIcon,
	},
	watch: {
		search: function(n, o) {
			this.$emit('search', n);
			this.debounceQuery(n);
		}
	},
	computed: {
		resultsItemsSize() {
			const l = this.results.length

			if (!l)
				return 0

			return this.$refs.select.scrollHeight / l
		}
	},
	created() {
		this.debounceQuery = debounce(this.query, 500);
	},
	data() {
		return {
			search: "",
			results: [],
			placeholder: texts.searchPlaceholder,
			focusedItem: 0,
			focusedId: -1,
		};
	},
	methods: {
		min: Math.min,
		blur() {
			this.results = []
		},
		selectFocused() {
			if (!this.results.length)
				return
			this.select(this.focusedItem)
		},
		moveDown() {
			if (!this.results.length)
				return

			let length = this.results.length

			let f = this.focusedItem
			f ++

			if (f >= length) {
				f = 0
				this.$refs.select.scrollTop = 0
			}
			else {
				let scrollHeight = this.$refs.select.scrollHeight
				let clientHeight = this.$refs.select.clientHeight
				let itemHeight = scrollHeight / length
				let scrollTop = (f + 1) * itemHeight

				if (scrollTop < clientHeight) {
					scrollTop = 0
				}
				else {
					scrollTop = scrollTop - clientHeight
				}
				this.$refs.select.scrollTop = scrollTop
			}

			this.focusedItem = f
		},
		moveUp() {
			if (!this.results.length)
				return

			let length = this.results.length

			let f = this.focusedItem
			f --

			let scrollHeight = this.$refs.select.scrollHeight
			let clientHeight = this.$refs.select.clientHeight
			let itemHeight = scrollHeight / length
			let scrollTop = (f + 1) * itemHeight

			if (f < 0) {
				f = this.results.length - 1
				this.$refs.select.scrollTop = scrollHeight - itemHeight;
			}
			else {

				if (scrollTop < clientHeight) {
					scrollTop = 0
				}
				else {
					scrollTop = scrollTop - clientHeight
				}
				this.$refs.select.scrollTop = scrollTop
			}

			this.focusedItem = f

		},
		unsearch() {
			this.search = ""
			this.results = []
			this.placeholder = texts.search
			this.focusedItem = 0
		},
		unfocus() {
			this.focusedItem = 0
		},
		select(index) {
			const lieu = this.results[index]
			this.unsearch()
			this.unfocus()
			this.placeholder = lieu.nom + ' ('+lieu.codeDepartement+')'

			pageView('/ville/' + lieu.nom + '-' + lieu.codeDepartement)

			let ville = {
				coords: L.latLng(lieu.centre.coordinates[1], lieu.centre.coordinates[0]),
				nom: lieu.nom,
				departement: lieu.codeDepartement
			}
			this.$emit('select', ville)
		},
		query: function(s) {
			this.results = [];
			this.unfocus()

			if (s.length < 2)
				return

            const params = {
                fields: "nom,code,centre,codeDepartement,"
            };

			if (s.match(/^[0-9]/)) {
				switch (s.length) {
					case 2:
						params.codeDepartement = s;
						break;
					case 5:
						params.codePostal = s;
						break;
					default:
						return
				}
			}
			else {
				params.nom = diacritics.remove(s)
			}

			axios.get(process.env.VUE_APP_API_ADDR, {
				params: params
			})
				.then((response) => {
					this.results = response.data.filter( (item) => parseInt(item.codeDepartement) < 97 );
				})
				.catch((error) => {
					this.results = [error];
				});
		},
	},
}
</script>


<style scoped lang="scss">

.search {
	width: 100%;
}

.search-wrapper {

	width: 100%;
	background-color: #fff;
	max-width: 500px;
	margin: 0 auto;
	position: relative;
	box-shadow: none;
	border: 1px solid rgba(0, 0, 0, 0.2);
/*
	@include from($tablet) {
		max-width: 400px;
	}

	@include from($desktop) {
		max-width: 500px;
	}
*/
}


.input-field {
	display: flex;
	padding: 3px 11px;
	justify-content: stretch;
	align-items: center;
	box-shadow: inset 1px 1px 3px 0px rgba(0, 0, 0, 0.2);
}

input,
.input {
	flex-grow: 1;
	border: none !important;
	padding:0;
	outline: none;
	box-shadow: none !important;

	@extend %font-search;


	&:focus,
	&:hover,
	&:active {
		border: none !important;
		box-shadow: none !important;
	}



	&::-webkit-input-placeholder { /* WebKit, Blink, Edge */
		@extend %font-placeholder;
	}
	&:-moz-placeholder { /* Mozilla Firefox 4 to 18 */
		@extend %font-placeholder;
	}
	&::-moz-placeholder { /* Mozilla Firefox 19+ */
		@extend %font-placeholder;
	}
	&:-ms-input-placeholder { /* Internet Explorer 10-11 */
		@extend %font-placeholder;
	}
	&::-ms-input-placeholder { /* Microsoft Edge */
		@extend %font-placeholder;
	}
	&::placeholder { /* Most modern browsers support this now. */
		@extend %font-placeholder;
	}

}

.results {
	position: relative;

	.results-wrapper {
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		max-height: 70vh;
		overflow-x: hidden;
		overflow-y: auto;
		background-color: #fff;
		border: 1px solid rgba(0, 0, 0, 0.2);
		border-top: none;
		margin-left: -1px;
		margin-right: -1px;

		> * {
			padding: 6px 10px;
			cursor: pointer;

			&.focused {
				background-color: $rouge;
				color: #fff;
			}

			&:hover,
			&.active {
				background-color: #ccc;
				color: #000;
			}
		}
	}


	.nom {
		@extend %font-result;
	}

	.departement {
		@extend %font-result-departement;

		padding-left: .5rem;

		&:after {
			content:")";
		}
		&:before {
			content:"(";
		}
	}

}

.icon {
	width: 1rem;
	display: flex;
	align-items: center;
	justify-content: center;
	background-color: #fff;
	cursor: pointer;

	> * {
		fill: $gris;
		transform-origin: 50%;
		//transform: scale(.8);
	}

}

.close-icon {
	//transform: scale(.6);
	max-width: 12px;
}

.search-icon {
	cursor: pointer;
	//transform: scale(1.24);
	max-width: 17px;
}
</style>
